<div class="card">
  <div class="card-header">
    <div class="activity">
      <img src="../App_Themes/clearview-default/images/challenges/shadowboxing/shadow_boxing.svg"
        alt="Shadow Boxing Icon" width="21" height="21" class="icon-16">
      <span class="metric-name">{{ challenge?.Metrics }}</span>
    </div>
    <div *ngIf="!!dateTitle" class="end-date">
      <span cvLocalizedText langSection="Challenges" [langKey]="dateTitle">End Date</span>
      : {{ dateValue }}
    </div>
  </div>

  <div class="card-body">
    <div class="score">
      <div class="score-content">
        <label class="today-score-text" cvLocalizedText langSection="Challenges_Create"
        langKey="Shadow_Boxing_Todays_Score">Today's score</label>
      <label class="today-score" [ngClass]="{
        'red-text-score': !reachDailyGoal && !isPendingChallenge,
        'green-text-score': reachDailyGoal && !isPendingChallenge,
        }">{{ myScore }}</label>
      </div>
    </div>
    <div class="goal">
      <div class="score-content">
        <label class="goal-title" cvLocalizedText langSection="Challenges_Create" langKey="Daily_Goal_Card">Daily
          Goal</label>
        <label class="goal-score-text">{{ scoreGoal }}</label>
      </div>
    </div>
    <div class="reward">
      <label class="reward-title" cvLocalizedText langSection="Challenges_Create" langKey="Reward">Reward</label>
      <div class="reward-content">
        <img src="../App_Themes/clearview-default/images/challenges/shadowboxing/Gems.svg" alt="Shadow Boxing Icon"
          width="12" height="9" class="icon-16">
        <span class="reward-text">{{ reward }}</span>
      </div>
    </div>
  </div>
  <div *ngIf="hasPunch" class="punch-available">
    <span cvLocalizedText langSection="Challenges_Create" langKey="Punch_Available">Punch
      Available!
    </span>
  </div>
</div>